<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "EstateCompany"
}
</script>

<style scoped>

</style>